import React from 'react'
import { Link } from 'react-router-dom';
import classNames from "classnames";
import $ from "jquery";
import VideoYoutube from "./VideoYoutube";

class Musiques extends React.Component {

	static timeout = null;
	static currentPhoto = 0;

	_elems = [];

	constructor(props) {
		super(props);

		this.state = {
			history: props.history,
			prev: false,
			next: true,
			images: [
				{src: 'https://www.youtube.com/embed/uyTVyCp7xrw', titre: 'Entrée des mariés dans la salle & ouverture dessert'},
				{src: 'https://www.youtube.com/embed/JkK8g6FMEXE', titre: 'Ouverture du balle'},
				{src: 'https://www.youtube.com/embed/Ycg5oOSdpPQ', titre: 'Musique de la chorégraphie'},
				{src: 'https://www.youtube.com/embed/VfwmY3NAXs4', titre: 'Discours & chant de la famille de coeur de Marine'},
				{src: 'https://www.youtube.com/embed/UJhj5n6hiKM', titre: 'Enregistrement des Volo pour les mariés'},
				{src: 'https://www.youtube.com/embed/81dWdeDjfC4', titre: 'Discours du marié'},
				{src: 'https://www.youtube.com/embed/Bxh_wMIW-n8', titre: 'Discours du marié'},
			],
		};

		this.key = 'musiques';
		this.nom = 'Musiques';
	}

	shouldComponentUpdate(nextState) {
		return nextState !== this.state;
	}

	setCurrent = (id) =>
	{
		console.log(this._elems);
		for (let key = 0; key < this._elems.length; key++) {
			this._elems[key].setState({
				current: false,
			});
		}
		this._elems[id].setState({
			current: true,
		});

		Musiques.currentPhoto = id;

		return null;
	};

	addPhoto = (photo) =>
	{
		this._elems.push(photo);
	};

	prev = () =>
	{
		if(!this.first())
			this.goTo(Musiques.currentPhoto - 1);
	};

	next = () =>
	{
		if(!this.last())
			this.goTo(Musiques.currentPhoto + 1);
	};

	first = () =>
	{
		return Musiques.currentPhoto <= 0;
	};

	last = () =>
	{
		return Musiques.currentPhoto + 1 >= this._elems.length;
	};

	goTo = (id) =>
	{
		let hash = 'photo'+id;

		this.setCurrent(id);

		const gallerie = document.getElementById('gallerie');
		const el = document.getElementById(hash);
		const elOffset = el.offsetLeft;
		const windowWidth = $(gallerie).width();
		const elWidth = el.getBoundingClientRect().width;

		$(gallerie).scrollLeft(elOffset - windowWidth / 2 + elWidth / 2);

		this.setState({
			'prev': this.first(),
			'next': this.last(),
		});
	};

	onKeyDown = (e) =>
	{
		if(e.keyCode === 37)
			this.prev();
		else if(e.keyCode === 39)
			this.next();
		else if(e.keyCode === 27)
			this.props.history.push("/");
	};

	handleScroll = () =>
	{
		if(Musiques.timeout)
			clearTimeout(Musiques.timeout);
		Musiques.timeout = setTimeout(Musiques.checkVisiblePhotos, 50);
	};

	checkVisiblePhotos = () =>
	{
		for (let key = 0; key < 8; key++) {
			if(this._elems[key].checkVisible())
				this._elems[key].setState({'current': true});
			else
				this._elems[key].setState({'current': false});
		}
	};

	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown);
		//setTimeout(() => { this.goTo(0) }, 300)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown);
	}

	getClassNamesPrev = () =>
	{
		return classNames({
			'disable': this.state.prev,
			'hi-icon': true,
			'prev': true,
		});
	};

	getClassNamesNext = () =>
	{
		return classNames({
			'disable': this.state.next,
			'hi-icon': true,
			'next': true,
		});
	};

	render() {

		let that = this;

		console.log(this.state);

		return (
			<div id="slider" onScroll={this.handleScroll}>
				<div id="gallerie" className="gallerie">
					<div className="wrap">
						{this.state.images.map(function(img, i){
							return <VideoYoutube data={img} id={i} key_album={that.key} prev={that.prev} next={that.next} goTo={that.goTo} addPhoto={that.addPhoto} />;
						})}
					</div>
				</div>
				<h1>
					Musiques
				</h1>

				<div id="header-droit">
					<Link to='/'>
						<span className="hi-icon"><i className="icon-cancel"/></span>
					</Link>
				</div>

				<span onClick={this.prev} className={this.getClassNamesPrev()}><i className="icon-left-open"/></span>
				<span onClick={this.next} className={this.getClassNamesNext()}><i className="icon-right-open"/></span>

			</div>
		);
	}
}

export default Musiques;


// WEBPACK FOOTER //
// ./src/components/Musiques.js